import React, { useState } from "react";

const HotelDetailAbout = ({ hotelName, city, description, isMobile = false }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // Use actual description from database if available, otherwise fall back to generated text
    const hasRealDescription = description && description.trim().length > 0;
    const primaryText = hasRealDescription
        ? description
        : `Experience unparalleled luxury and hospitality at ${hotelName}. Nestled in the heart of ${city}, our property combines traditional charm with modern elegance.`;

    const fallbackExtended = `We take pride in offering top-notch facilities including 24-hour concierge service, high-speed Wi-Fi, premium bedding, and a range of dining options. Whether you're here for business or leisure, our team is dedicated to making your stay memorable.`;

    return (
        <div style={{ background: "#fff", borderRadius: "16px", padding: isMobile ? "14px" : "20px", boxShadow: "0 4px 15px rgba(0,0,0,0.04)", marginBottom: "20px", border: "1px solid #f5f5f5" }}>
            <h3 style={{ fontSize: isMobile ? "1.05rem" : "1.2rem", fontWeight: "900", marginBottom: "12px", color: "#1a1a1a", letterSpacing: "-0.5px" }}>About Property</h3>
            <div style={{ lineHeight: "1.6", color: "#555", fontSize: isMobile ? "0.86rem" : "0.95rem" }}>
                <p style={{ margin: 0 }}>
                    {!hasRealDescription && <><strong>{hotelName}</strong>. </>}
                    {primaryText}
                </p>
                {isExpanded && !hasRealDescription && (
                    <p style={{ marginTop: "12px", animation: "fadeIn 0.5s ease" }}>
                        {fallbackExtended}
                    </p>
                )}
                {!hasRealDescription && (
                    <div
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{ color: "#EE2E24", cursor: "pointer", fontWeight: "800", marginTop: "8px", display: "inline-flex", alignItems: "center", gap: "5px", fontSize: isMobile ? "0.8rem" : "0.85rem" }}
                    >
                        {isExpanded ? "READ LESS" : "READ MORE"} <span style={{ fontSize: "1rem" }}>{isExpanded ? "▴" : "▾"}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HotelDetailAbout;
